export const environment = {
    appVersion: require('../../package.json').version + ' ' + require('../../package.json').updateDate,
    production: true,
    hmr       : false,
    appName: 'marvel-web-prod',
    cacheVersion: 5,
    serverUrl: 'https://api-isabuy-prod.sabuytech.com/v1',
    baseAuthApi: 'https://api-isabuy-prod.sabuytech.com/v1',
    credentialsKey: 'credentials',
    notificationRef: 'notification-prod',
    notificationReloadRef: 'notification-reload-prod'
    //apiUrl: 'https://marvel-api.atthaisolutions.com',
};
